import * as n from "react";
import { u as O, c as S, a as D } from "./index-DjWSt7QJ.js";
import { c as M, P as b, u as L } from "./index-Bm60c36x.js";
import { P as k } from "./index-Db-zVn-7.js";
import { u as F } from "./index-jREDPgkq.js";
import { jsx as c } from "react/jsx-runtime";
var v = "Collapsible", [B, K] = M(v), [G, g] = B(v), T = n.forwardRef(
  (e, r) => {
    const {
      __scopeCollapsible: s,
      open: a,
      defaultOpen: t,
      disabled: l,
      onOpenChange: i,
      ...f
    } = e, [p = !1, d] = O({
      prop: a,
      defaultProp: t,
      onChange: i
    });
    return /* @__PURE__ */ c(
      G,
      {
        scope: s,
        disabled: l,
        contentId: F(),
        open: p,
        onOpenToggle: n.useCallback(() => d((m) => !m), [d]),
        children: /* @__PURE__ */ c(
          b.div,
          {
            "data-state": h(p),
            "data-disabled": l ? "" : void 0,
            ...f,
            ref: r
          }
        )
      }
    );
  }
);
T.displayName = v;
var w = "CollapsibleTrigger", A = n.forwardRef(
  (e, r) => {
    const { __scopeCollapsible: s, ...a } = e, t = g(w, s);
    return /* @__PURE__ */ c(
      b.button,
      {
        type: "button",
        "aria-controls": t.contentId,
        "aria-expanded": t.open || !1,
        "data-state": h(t.open),
        "data-disabled": t.disabled ? "" : void 0,
        disabled: t.disabled,
        ...a,
        ref: r,
        onClick: S(e.onClick, t.onOpenToggle)
      }
    );
  }
);
A.displayName = w;
var R = "CollapsibleContent", I = n.forwardRef(
  (e, r) => {
    const { forceMount: s, ...a } = e, t = g(R, e.__scopeCollapsible);
    return /* @__PURE__ */ c(k, { present: s || t.open, children: ({ present: l }) => /* @__PURE__ */ c($, { ...a, ref: r, present: l }) });
  }
);
I.displayName = R;
var $ = n.forwardRef((e, r) => {
  const { __scopeCollapsible: s, present: a, children: t, ...l } = e, i = g(R, s), [f, p] = n.useState(a), d = n.useRef(null), m = L(r, d), P = n.useRef(0), y = P.current, x = n.useRef(0), N = x.current, C = i.open || f, _ = n.useRef(C), u = n.useRef(void 0);
  return n.useEffect(() => {
    const o = requestAnimationFrame(() => _.current = !1);
    return () => cancelAnimationFrame(o);
  }, []), D(() => {
    const o = d.current;
    if (o) {
      u.current = u.current || {
        transitionDuration: o.style.transitionDuration,
        animationName: o.style.animationName
      }, o.style.transitionDuration = "0s", o.style.animationName = "none";
      const E = o.getBoundingClientRect();
      P.current = E.height, x.current = E.width, _.current || (o.style.transitionDuration = u.current.transitionDuration, o.style.animationName = u.current.animationName), p(a);
    }
  }, [i.open, a]), /* @__PURE__ */ c(
    b.div,
    {
      "data-state": h(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !C,
      ...l,
      ref: m,
      style: {
        "--radix-collapsible-content-height": y ? `${y}px` : void 0,
        "--radix-collapsible-content-width": N ? `${N}px` : void 0,
        ...e.style
      },
      children: C && t
    }
  );
});
function h(e) {
  return e ? "open" : "closed";
}
var Q = T, U = A, V = I;
export {
  V as C,
  Q as R,
  U as T,
  K as c
};
